import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";
import { Typography } from "@circle-react-uikit/Typography";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";

import { CheckoutFormSection } from "../CheckoutFormSection";
import { CheckoutFormAccountDetails } from "./CheckoutFormAccountDetails";
import { CheckoutFormEmailVerification } from "./CheckoutFormEmailVerification";

export const CheckoutFormAccountInfo = Object.assign(
  () => {
    const { currentUser } = usePaywallCheckoutContext();
    const { isLoading: isCommunityLoading } = usePunditUserContext();

    if (isCommunityLoading) return null;

    return (
      <div className="flex flex-col gap-y-4 lg:pb-6">
        <div>
          <Typography.TitleSm weight="semibold">
            {t("paywall_checkout.your_account")}
          </Typography.TitleSm>
        </div>

        <CheckoutFormSection className="gap-y-5 !py-0">
          {currentUser ? (
            <CheckoutFormAccountDetails />
          ) : (
            <CheckoutFormEmailVerification />
          )}
        </CheckoutFormSection>
      </div>
    );
  },
  {
    Skeleton: () => (
      <div className="flex flex-col gap-y-4 lg:pb-6">
        <Row square xl half />

        <CheckoutFormSection className="gap-y-5 !py-0">
          <div
            className={classNames(
              "flex flex-col gap-y-4 p-6",
              "border-primary shadow-xs rounded-xl border bg-white",
              "relative w-full overflow-hidden",
              "mx-auto",
              "sm:mx-auto md:mx-0",
            )}
          >
            <Row square half />
            <Row square full x2l />
          </div>
        </CheckoutFormSection>
      </div>
    ),
  },
);
